// Takes an array of critical factors
// Returns credit factor and equity factors separated
// On the basis of criticalFactorType
// Possible values "Credit" or "Equity"

const CREDIT = 'Credit';
const EQUITY = 'Equity';
const CLOVERS = 'Clovers';

const cfFilter = (factorsArray) => {
    const creditFactors = [],
        equityFactors = [],
        cloversFactors = [];

    factorsArray.forEach((factor) => {
        if (factor.criticalFactorType === CREDIT) {
            creditFactors.push(factor);
        } else if (factor.criticalFactorType === EQUITY) {
            equityFactors.push(factor);
        } else if (factor.criticalFactorType === CLOVERS) {
            cloversFactors.push(factor);
        }
    });

    return {creditFactors, equityFactors, cloversFactors};
};

export default cfFilter;
